
import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { GamificationRuleService }   from '../gamification-rule/gamification-rule.service';
import { BaseService } from '../../shared-service/base.service';
declare var jquery:any;
declare var $:any;

@Component({
  selector: 'app-gamification-rule',
  templateUrl: './gamification-rule.component.html',
  styleUrls: ['./gamification-rule.component.css']
})
export class GamificationRuleComponent implements OnInit, OnChanges {
  bs: BaseService;
  @Input() learningItem: Object = {};
  private params: Object = {};
  public gamificationAreaData: Array<{AreaName:any,Rules:Array<any>}> = [];
  public gamificationPoints: string = "";
  @Output() markChanges = new EventEmitter<Object>();

  constructor(public baseService : BaseService,private gamificationService: GamificationRuleService, private changeDetector: ChangeDetectorRef) {
    this.bs = baseService;
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.bs.log('info'," Gamification Rule Component Something Changed");

  if(changes.learningItem.currentValue['CourseID']!=null)
  {
    if(changes.learningItem.currentValue['ILTID']!=null && (changes.learningItem.currentValue['LearningType']=='T'||changes.learningItem.currentValue['CourseType']=='T'))
    {
      this.params = {
        'LearningId': changes.learningItem.currentValue['ILTID'],
        'LearningType': 'ILT',
      };
    }
    else
    {
      this.params = {
        'LearningId': changes.learningItem.currentValue['CourseID'],
        'LearningType': 'NODE',
      };
    }
}
  else if(changes.learningItem.currentValue['VideoId']!=null)
  {
      this.params = {
        'LearningId': changes.learningItem.currentValue['VideoId'],
        'LearningType': 'VIDEO',
      };
  }
  else if(changes.learningItem.currentValue['SurveyId']!=null)
  {
      this.params = {
        'LearningId': changes.learningItem.currentValue['SurveyId'],
        'LearningType': 'SURVEY',
      };
  }
  else if(changes.learningItem.currentValue['Id']!=null )
  {
      this.params = {
        'LearningId': changes.learningItem.currentValue['Id'],
        'LearningType': 'ILT',
      };
  }
  else
  {
    this.params = {
      'LearningId': changes.learningItem.currentValue[0]['conversationId'],
      'LearningType': 'CONVERSATION',
  };
  }

    this.gamificationService.getGamificationRulesFromServer(this.params, "****").then((data:any) => {
      this.gamificationAreaData = data['GamificationAreaRules'];
      this.gamificationPoints=data['TotalPoints'];
      this.bs.log('info','Gamification Rule Component data :- '+JSON.stringify(data));
    }, (data) => {
      this.bs.log('error','Error in getting list');
    });
    this.markChanges.emit({'x':1});

  };

  hideGamificationRule()
  {

    let obj = {};
    $('.hideDiv').hide();
    this.gamificationService.updateStoreData("****",obj);
  }
}


